module.exports = __webpack_public_path__ + "img/2-2.2ed6b996.png";